import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

function getUser() {
    return Auth.currentAuthenticatedUser().then((user) => {
        if (user && user.signInUserSession) {
            return user
        } else {
            return null
        }
    }).catch((err) => {
        throw err
     });
}

function signUp(username, password, email, phone_number) {
    return Auth.signUp({
        username,
        password,
        attributes: {
            email: email,
            phone_number: phone_number,
        },
    })
        .then(data => {

            AmplifyEventBus.$emit('localUser', data.user);
            AmplifyEventBus.$emit('authState', 'signIn');

            return data;
        })
        .catch(err => {
            throw err
        });
}

function confirmSignUp(username, code) {
    return Auth.confirmSignUp(username, code).then(data => {

        AmplifyEventBus.$emit('authState', 'confirmScreen')

        return data // 'SUCCESS'
    })
        .catch(err => {
            return {err};
        });
}

function resendSignUp(username) {
    return Auth.resendSignUp(username).then(() => {
        return 'SUCCESS';
    }).catch(err => {
        return err;
    });
}

async function forgotPassword(username,store) {
    try {
        const user = await Auth.forgotPassword(username);
        if (user) {
                AmplifyEventBus.$emit('authState', 'forgotPassword');
        } else {
            store.dispatch("setGlobalError",{value: "User does not exist."})
        }
    } catch (err) {
        store.dispatch("setGlobalError",{value: err.message})
        // if (err.code === 'UserNotConfirmedException') {
        //     // The error happens if the user didn't finish the confirmation step when signing up
        //     // In this case you need to resend the code and confirm the user
        //     // About how to resend the code and confirm the user, please check the signUp part
        // }
    }
}

async function forgotPasswordSubmit(username,code,password,store) {
    try {
        const response = await Auth.forgotPasswordSubmit(username, code, password);
        if(!response) {
            AmplifyEventBus.$emit('authState', 'signIn');
        }
    } catch (err) {
        store.dispatch("setGlobalError",{value: err.message})
        // if (err.code === 'UserNotConfirmedException') {
        //     // The error happens if the user didn't finish the confirmation step when signing up
        //     // In this case you need to resend the code and confirm the user
        //     // About how to resend the code and confirm the user, please check the signUp part
        // }
    }
}

async function signIn(username, password, store, registration) {
    try {
        const user = await Auth.signIn(username, password); // Cognito
        if (user) {
            if(registration === 0) {
                AmplifyEventBus.$emit('authState', 'signedIn');
            } else {
                AmplifyEventBus.$emit('authState', 'signInRegistration');
            }
        } else {
            store.dispatch("setGlobalError",{value:"User does not exist"})
        }
    } catch (err) {
        store.dispatch("setGlobalError",{value:err.message})
        if (err.code === 'UserNotConfirmedException') {
            // The error happens if the user didn't finish the confirmation step when signing up
            // In this case you need to resend the code and confirm the user
            // About how to resend the code and confirm the user, please check the signUp part
        } else if (err.code === 'PasswordResetRequiredException') {
            // The error happens when the password is reset in the Cognito console
            // In this case you need to call forgotPassword to reset the password
            // Please check the Forgot Password part.
        } else if (err.code === 'NotAuthorizedException') {
            // The error happens when the incorrect password is provided
        } else if (err.code === 'UserNotFoundException') {
            // The error happens when the supplied username/email does not exist in the Cognito user pool
        }
    }
}

function signOut() {
    return Auth.signOut()
        .then(data => {
            AmplifyEventBus.$emit('authState', 'signedOut');
            return data;
        })
        .catch(err => {
            return err;
        });
}

export { getUser, signUp, confirmSignUp, resendSignUp, signIn, signOut, forgotPassword, forgotPasswordSubmit };
